import humps from 'humps'

import { AUTH_TOKEN, SUBSCRIBE_CART, AUTH_TOKEN_CUSTOMER } from './../constants'

const setRecurrenceAuthToken = token => localStorage.setItem(AUTH_TOKEN, token)

const getRecurrenceAuthToken = () => localStorage.getItem(AUTH_TOKEN)

const hasRecurrenceAuthToken = () => !!getRecurrenceAuthToken()

const removeRecurrenceAuthToken = () => localStorage.removeItem(AUTH_TOKEN)

const getUserIdFromToken = () => {
  try {
    const token = getRecurrenceAuthToken()
    const payload = humps.camelizeKeys(JSON.parse(atob(token.split('.')[1])))

    return payload.userId
  } catch (error) {
    return ''
  }
}

const setRecurrenceAuthTokenCustomer = token =>
  localStorage.setItem(AUTH_TOKEN_CUSTOMER, token)

const getRecurrenceAuthTokenCustomer = () =>
  localStorage.getItem(AUTH_TOKEN_CUSTOMER)

const hasRecurrenceAuthTokenCustomer = () => !!getRecurrenceAuthTokenCustomer()

const removeRecurrenceAuthTokenCustomer = () =>
  localStorage.removeItem(AUTH_TOKEN_CUSTOMER)

const getCustomerIdFromToken = () => {
  try {
    const token = getRecurrenceAuthTokenCustomer()
    const payload = humps.camelizeKeys(JSON.parse(atob(token.split('.')[1])))

    return payload.customerId
  } catch (error) {
    return ''
  }
}

const setRecurrenceSubscribeCart = cart =>
  localStorage.setItem(SUBSCRIBE_CART, JSON.stringify(cart))

const getRecurrenceSubscribeCart = () =>
  JSON.parse(localStorage.getItem(SUBSCRIBE_CART)) || []

export default {
  setRecurrenceAuthToken,
  getRecurrenceAuthToken,
  hasRecurrenceAuthToken,
  removeRecurrenceAuthToken,
  getUserIdFromToken,

  setRecurrenceAuthTokenCustomer,
  getRecurrenceAuthTokenCustomer,
  hasRecurrenceAuthTokenCustomer,
  removeRecurrenceAuthTokenCustomer,
  getCustomerIdFromToken,

  setRecurrenceSubscribeCart,
  getRecurrenceSubscribeCart,
}
